
import React, { Component } from "react";
import { connect } from "react-redux";
import { saveSOHSettings } from "../../../../../../store/actions";

class ECExportText extends Component {
  state = {
    isEdit: false
  };

  async componentDidMount() {
    this.setState({ earningCodeExportText: this.props.SOH_SETTINGS?.earningCodeExportText || "" });
  }


  async componentDidUpdate(prevProps) {
    if (!prevProps.SOH_SETTINGS?.earningCodeExportText && this.props.SOH_SETTINGS?.earningCodeExportText) {
      this.setState({ earningCodeExportText: this.props.SOH_SETTINGS?.earningCodeExportText || "" });
    };
  }

  updateECExportText = e => this.setState({ earningCodeExportText: e.target.value });

  render() {
    return (
      <div className="reportId ">

        {!this.state.isEdit ? (
          <div className="df align-items-center justify-content-between">
            <div className="reportIdField ExportEarning">

              Earning Code Export Text: {this.state.earningCodeExportText}{" "}

            </div>
            <div className="reportIdField">
              <button className="btn reportBtn" onClick={() => this.setState({ isEdit: true })}>Edit</button>
            </div>
          </div>
        ) : (
          <div className="df align-items-center justify-content-between">
            <div className="reportIdField ExportEarning">
              <input type="text"
                value={this.state.earningCodeExportText}
                onChange={this.updateECExportText}
              />

            </div>
            <div className="reportIdField">
              <button className="btn reportBtn" onClick={async () => {
                await this.props.saveSOHSettings(this.props.ClientDataReducer._id, {
                  earningCodeExportText: this.state.earningCodeExportText,
                });

                this.setState({ isEdit: false });
              }}>Save</button>
            </div>

          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ ClientDataReducer, SOHSettingsReducer }) => {
  let { SOH_SETTINGS } = SOHSettingsReducer;
  return { ClientDataReducer, SOH_SETTINGS };
};

export default connect(mapStateToProps, {
  saveSOHSettings
})(ECExportText);
